import { MCBNS020EditMessageTemplateRequest } from 'types/MCBNS020/MCBNS020EditMessageTemplateRequest'
import { MCBNS020InitDisplayRequest } from 'types/MCBNS020/MCBNS020InitDisplayRequest'
import { MCBNS020updateAutoReservationRemindMessageRequest } from 'types/MCBNS020/MCBNS020updateAutoReservationRemindMessageRequest'
import request from 'utils/request'

export const openAutoReservationRemindApi = (requestdata: MCBNS020InitDisplayRequest) =>
  request({
    url: '/MCBNS020/init',
    method: 'post',
    data: requestdata
  })

export const linkSelectedTemplate1Api = (requestdata: MCBNS020EditMessageTemplateRequest) =>
  request({
    url: '/MCBNS020/linkSelectedTemplate1',
    method: 'post',
    data: requestdata
  })

export const linkSelectedTemplate2Api = (requestdata: MCBNS020EditMessageTemplateRequest) =>
  request({
    url: '/MCBNS020/linkSelectedTemplate2',
    method: 'post',
    data: requestdata
  })

export const confirmAutoReservationRemindApi = (requestdata: MCBNS020updateAutoReservationRemindMessageRequest) =>
  request({
    url: '/MCBNS020/update',
    method: 'post',
    data: requestdata
  })

export const messageTemplateReloadApi = () =>
  request({
    url: '/MCBNS020/messageTemplateReload',
    method: 'post',
  })